import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import { useSvgId } from 'src/hooks';

export const DocumentsIcon = memo(
  forwardRef((props, ref) => {
    const svgId = useSvgId();

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
        data-fill-none
      >
        <g clipPath={`url(#${svgId})`}>
          <path
            d="M17.1043 3.3575L6.05592 14.4058C5.82159 14.6402 5.68994 14.9581 5.68994 15.2896C5.68994 15.621 5.82159 15.9389 6.05592 16.1733L7.82342 17.9417C7.93951 18.0578 8.07734 18.15 8.22905 18.2128C8.38076 18.2757 8.54337 18.3081 8.70759 18.3081C8.87181 18.3081 9.03442 18.2757 9.18613 18.2128C9.33784 18.15 9.47567 18.0578 9.59176 17.9417L20.6401 6.8925C21.1026 6.42232 21.3605 5.78844 21.3578 5.12893C21.355 4.46942 21.0917 3.83772 20.6253 3.37143C20.1589 2.90513 19.5272 2.64203 18.8677 2.63942C18.2082 2.63681 17.5743 2.89491 17.1043 3.3575ZM17.1043 3.3575C16.8721 3.12531 16.5965 2.94113 16.2931 2.81546C15.9898 2.6898 15.6647 2.62512 15.3363 2.62512C15.008 2.62512 14.6829 2.6898 14.3795 2.81546C14.0762 2.94113 13.8006 3.12531 13.5684 3.3575L10.9168 6.00917M14.0109 6.45084L17.5459 9.98667"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.95089 17.0684C7.29874 17.4363 7.48802 17.9262 7.47789 18.4324C7.46775 18.9386 7.25902 19.4205 6.89672 19.7742C6.14256 20.5292 2.62256 21.3751 2.62256 21.3751C2.62256 21.3751 3.49089 17.8751 4.24506 17.1251C4.5983 16.7622 5.08009 16.5529 5.58636 16.5423C6.09264 16.5317 6.58277 16.7207 6.95089 17.0684Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="20"
              height="20"
              fill="currentColor"
              transform="translate(2 2)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
